var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';
import { RolesService } from '@app/core';
import { ScopesActionTypes, CompleteLoadScopeCategoriesAction, FailLoadScopeCategoriesAction, CompleteLoadScopeConstraintsAction, FailLoadScopeConstraintsAction } from './role-scope.actions';
var ScopesEffects = /** @class */ (function () {
    function ScopesEffects(actions$, rolesService) {
        var _this = this;
        this.actions$ = actions$;
        this.rolesService = rolesService;
        this.requestOnLoadScopeCategories$ = this.actions$.pipe(ofType(ScopesActionTypes.SCOPE_CATEGORIES_LOADING), flatMap(function (action) { return _this.requestScopeCategories(); }));
        this.requestOnLoadScopeConstraints$ = this.actions$.pipe(ofType(ScopesActionTypes.SCOPE_CONSTRAINTS_LOADING), flatMap(function (action) { return _this.requestScopeConstraints(action.payload); }));
    }
    ScopesEffects.prototype.requestScopeCategories = function () {
        return this.rolesService
            .getScopeCategories()
            .pipe(map(function (scopes) { return new CompleteLoadScopeCategoriesAction(scopes); }), catchError(function (_) { return of(new FailLoadScopeCategoriesAction()); }));
    };
    ScopesEffects.prototype.requestScopeConstraints = function (categoryId) {
        return this.rolesService
            .getScopeConstraints(categoryId)
            .pipe(map(function (constraints) { return new CompleteLoadScopeConstraintsAction({ categoryId: categoryId, constraints: constraints }); }), catchError(function (_) { return of(new FailLoadScopeConstraintsAction(categoryId)); }));
    };
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], ScopesEffects.prototype, "requestOnLoadScopeCategories$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], ScopesEffects.prototype, "requestOnLoadScopeConstraints$", void 0);
    return ScopesEffects;
}());
export { ScopesEffects };



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-scope.effects.ts.pre-build-optimizer.js